<div class="grid mt-0">
	<div class="col-12 pb-1 flex" [class]="onExtendedMobile() ? 'justify-content-center' : 'justify-content-start'">
		<p-button
					label="{{ 'ADD_STEP' | translate }}"
					icon="pi cm-plus" styleClass="font-bold border-primary"
					[rounded]="false" [text]="true" severity="primary"
					(click)="addStep()">
		</p-button>
	</div>
	<!-- 	<p-button class="hidden-over-md"
					label="{{ 'EXECUTE_SCENARIO' | translate }}"
					icon="pi cm-play-action" styleClass="font-bold"
					[rounded]="false" [text]="true" severity="secondary"
					(click)="executeScenery(scenery)">
		</p-button>
	</div>
	<div class="col-12 pt-0 pb-1 flex justify-content-center">
		<p-button class="hidden-over-md"
					label="{{ 'EDIT_SCENARIO' | translate }}"
					icon="pi cm-pencil" styleClass="font-bold"
					[rounded]="false" [text]="true" severity="secondary"
					(click)="editScenery(scenery)">
		</p-button>
		<p-button class="hidden-over-md"
					label="{{ 'DELETE_SCENARIO' | translate }}"
					icon="pi cm-trash" styleClass="font-bold"
					[rounded]="false" [text]="true" severity="danger"
					(click)="deleteScenery(scenery)">
		</p-button> 
	</div> -->
</div>
<!-- CARD CORE -->
<p-table [value]="sceneryStep" [reorderableColumns]="true" (onRowReorder)="rowReorder()"
    responsiveLayout="stack">
	<ng-template pTemplate="header" let-columns>
		<tr>
			<th *ngIf="(this.screenWidth > 1355)" style="width:3rem" [disabled]="!currentSite.CurrentlyOwned"></th>
			<th><div class="flex align-items-center justify-content-center">{{ 'FIRST_NAME' | translate }}</div></th>
			<th><div class="flex align-items-center justify-content-center">{{ 'DEVICE' | translate }}</div></th>
			<th><div class="flex align-items-center justify-content-center">{{ 'ACTION_TYPE' | translate }}</div></th>
			<th><div class="flex align-items-center justify-content-center">{{ 'ACTION' | translate }}</div></th>
			<th></th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" let-step let-columns="columns" let-index="rowIndex">
		<tr [pReorderableRow]="index">
			<td *ngIf="(this.screenWidth > 1355)">
            <span class="p-column-title"></span>
				<span class="pi cm-bars" pReorderableRowHandle></span>
			</td>
			<td>
            <span class="p-column-title font-semibold">{{ 'FIRST_NAME' | translate }}</span>
            <div class="flex align-items-center justify-content-center">{{ step.Name }}</div></td>
			<td>
            <span class="p-column-title font-semibold">{{ 'DEVICE' | translate }}</span>
            <div class="flex align-items-center justify-content-center">{{ getDeviceName(step) }}</div></td>
			<td>
            <span class="p-column-title font-semibold">{{ 'ACTION_TYPE' | translate }}</span>
            <p-tag [value]="getActionTypeTxt(step)" [styleClass]="getActionTypeColorTag(step)"></p-tag>
			<td>
            <span class="p-column-title font-semibold">{{ 'ACTION' | translate }}</span>
            <div class="flex align-items-center justify-content-center">{{ getAction(step) }}</div></td>
			<td>
            <span class="p-column-title font-semibold"></span>
				<div class="flex flex-row justify-content-center align-items-center gap-1">
					<p-button pTooltip="{{ 'EDIT' | translate}}"
						tooltipPosition="bottom" icon="pi cm-pencil" size="large"  [disabled]="!currentSite.CurrentlyOwned"
						(click)="editStep(step)" [rounded]="false" [text]="true" severity="secondary">
					</p-button>
					<p-button pTooltip="{{ 'DELETE' | translate}}"
						tooltipPosition="bottom" icon="pi cm-trash" size="large"  [disabled]="!currentSite.CurrentlyOwned"
						(click)="deleteStep(step)" [rounded]="false" [text]="true" severity="danger">
					</p-button>
				</div>
			</td>
		</tr>
	</ng-template>
	<ng-template pTemplate="emptymessage">
		<tr>
			<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
		</tr>
	</ng-template>
</p-table>

<p-confirmDialog #confDialog>
    <ng-template pTemplate="footer">
      <div class="col-12 flex justify-content-center">
        <button type="button" pButton
          [label]="confDialog.acceptButtonLabel"
          [ngClass]="acceptButtonStyle"
          (click)="confDialog.accept()">
        </button>
        <button type="button" pButton
          [label]="confDialog.rejectButtonLabel"
          [ngClass]="rejectButtonStyle"
          (click)="confDialog.reject()">
        </button>
      </div>
    </ng-template>
  </p-confirmDialog>
